import { Link } from 'react-router-dom';
import { Row, Table } from 'reactstrap';
import SvgIcon from '../../../../CommonElements/SVG/SvgIcon';
import { useAppDispatch, useAppSelector } from '../../../../ReduxToolkit/Hooks';
import { removeCartData } from '../../../../ReduxToolkit/Reducers/CartSlice';
import { CartType } from '../../../../Type/Application/Ecommerce/Product';
import { Href } from '../../../../utils/Constant';
import CartAction from './CartAction';
import CartQuantityButton from './CartQuantityButton';
import CartTableHead from './CartTableHead';
import EmptyCart from './EmptyCart';
import { formatPrice } from '../../../../utils/helper/helpers';

const CartData = () => {
  const dispatch = useAppDispatch();
  const { cart } = useAppSelector((state) => state.cartData);
  const removeFromCart = (item: CartType) => dispatch(removeCartData(item.id));
  return (
    <>
      {cart && cart.length > 0 ? (
        <Row>
          <div className="order-history wishlist">
            <Table bordered responsive>
              <CartTableHead />
              <tbody>
                {cart.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <div className="product-name">
                        {item.libelle}
                      </div>
                    </td>
                    <td>{formatPrice(item.prix_unitaire)} / {item.unite_de_mesure}</td>
                    <CartQuantityButton item={item} />
                    <td>{formatPrice(item.prix_unitaire * item.total)}</td>
                    <td>
                      <Link to={Href} onClick={() => removeFromCart(item)}><SvgIcon className='feather stroke-danger' iconId='x-circle' /></Link>
                    </td>
                  </tr>
                ))}
                <CartAction />
              </tbody>
            </Table>
          </div>
        </Row>
      ) : (
        <EmptyCart />
      )}
    </>
  )
}

export default CartData